import "./App.css";
import Calculator from "./components/calculator/Calculator";
import Counter from "./components/counter/Counter";
import Hangman from "./components/hangman/Hangman";

function App() {
  return (
    <>
      <Counter />
      <Calculator />
      <Hangman />
    </>
  );
}

export default App;
